<!-- The `voiceDocked ||` in front of the minimized check is deliberate and is NOT the same thing
     as ignoring the user's preference. While a call is docked this circle is the only Nova
     affordance that exists: the header badge hides itself on voiceDocked$, and FLIP-234's pill is
     gone. Without the override, a user who had minimised the launcher and then minimised a live
     call would be left with a running microphone and nothing at all on screen. The stored
     preference is untouched and takes over again the moment voice ends.
     `isMobileLayout ||` is the same override for the tab: there is no minimise-to-header on mobile
     (the header badge is hidden there too), so the preference - which a desktop session may have
     left in localStorage - must not be able to remove the only way into Nova. -->
<div
  *ngIf="showFab && (enabled$ | async) && (voiceDocked || isMobileLayout || !(minimized$ | async))"
  #fab
  flipCoachTarget="nova.launcher"
  class="nova-companion-fab"
  [class.nova-companion-fab--tab]="isMobileLayout"
  [class.nova-companion-fab--voice]="voiceDocked"
  [class.nova-companion-fab--speaking]="voiceDocked && meter?.speaking"
  role="button"
  tabindex="0"
  [title]="statusLabel"
  [attr.aria-label]="statusLabel"
  (click)="open()"
  (keydown.enter)="open()"
>
  <!-- The round launcher swaps the mascot for the wave while docked; the tab keeps it beside
       the label in both states, as in the Figma frames. -->
  <img
    *ngIf="!voiceDocked || isMobileLayout"
    class="nova-companion-fab__mascot"
    src="assets/nova/nova-mascot.png"
    alt=""
    aria-hidden="true"
  />

  <!-- Hidden from assistive tech: the button's aria-label already says this, and the live
       status below says what is happening. -->
  <span *ngIf="isMobileLayout" class="nova-companion-fab__tab-label" aria-hidden="true">{{
    tabLabel
  }}</span>

  <!-- Same markup as the in-sheet meter (nova-companion-chat.component.html), just fewer bars:
       real measured heights, no keyframes, so it stops moving when the room goes quiet. -->
  <span
    *ngIf="voiceDocked"
    class="nova-companion-fab__wave"
    [class.nova-companion-fab__wave--idle]="!meter?.hasSignal"
    aria-hidden="true"
  >
    <span
      *ngFor="let level of meter?.levels || []; trackBy: trackVoiceBar"
      [style.height.%]="level"
    ></span>
  </span>

  <!-- The deleted pill carried the only thing a screen reader got out of the minimised state, and
       a changed aria-label is not reliably re-announced - hence a live region rather than relying
       on the label binding above. -->
  <span *ngIf="voiceDocked" class="nova-companion-fab__status" aria-live="polite">{{
    statusLabel
  }}</span>

  <!-- Points up: the tab opens Nova upward off the bottom nav. -->
  <span *ngIf="isMobileLayout" class="nova-companion-fab__chevron" aria-hidden="true">
    <svg-icon
      src="assets/icons/icon-back.svg"
      [svgStyle]="{ 'width.px': 7, 'height.px': 10 }"
    ></svg-icon>
  </span>

  <!-- No minimise badge while a call is docked: the circle IS the minimised state, so a control
       that minimises it further has nothing left to collapse into. Nor on mobile, where the tab
       opens and closes in place and there is no header badge to minimise into. -->
  <button
    *ngIf="!voiceDocked && !isMobileLayout"
    type="button"
    class="nova-companion-fab__minimize"
    title="Minimize Nova"
    aria-label="Minimize Nova"
    (click)="onMinimize($event)"
  ></button>
</div>
